interface IAuth {
  getToken(): string
  setToken(token: any): void
  removeToken(): void
}
class Auth {
  private readonly TokenKey = 'M-Token'
  getToken() {
    return window.localStorage.getItem(this.TokenKey)
  }
  setToken(token: any): void {
    return window.localStorage.setItem(this.TokenKey, token)
  }
  removeToken(): void {
    return window.localStorage.removeItem(this.TokenKey)
  }
}
export default new Auth()
